import "./App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { useEffect, useState } from "react";
import { Header } from "./components/Header";
import { Footer } from "./components/Footer";
import { SeoManager } from "./components/Seo";
import { ShopProvider } from "./context/ShopContext";
import { useLenis } from "./hooks/useLenis";
import { apiRequest } from "./api";
import { Brand, Category, Product } from "./types";
import HomePage from "./pages/HomePage";
import CatalogPage from "./pages/CatalogPage";
import ProductPage from "./pages/ProductPage";
import BrandsPage from "./pages/BrandsPage";
import CartPage from "./pages/CartPage";
import AccountPage from "./pages/AccountPage";
import QuotePage from "./pages/QuotePage";
import { AboutPage, ContactPage, PrivacyPage, ReturnsPage, ShippingPage } from "./pages/InfoPages";
import { CategoryLandingPage, FAQPage, FinancingPage, LocationPage, ResourcesPage, TradePage, WhyBuyPage } from "./pages/MarketingPages";
import { ComparePage, WishlistPage } from "./pages/ShoppingTools";
import GuidePage from "./pages/GuidePage";
import RoomPage from "./pages/RoomPage";
import PartnerPage from "./pages/PartnerPage";
import { AccessibilityPage, TermsPage } from "./pages/PolicyPages";
import EcommerceSlugPage from "./pages/EcommerceSlugPage";
import AdminDashboardPage from "./pages/AdminDashboardPage";

function ScrollToTop() {
  const { pathname, search } = useLocation();
  useEffect(() => {
    window.requestAnimationFrame(() => {
      window.scrollTo({ top: 0, left: 0, behavior: "auto" });
      document.documentElement.scrollTop = 0;
      document.body.scrollTop = 0;
    });
  }, [pathname, search]);
  return null;
}

function AppContent() {
  useLenis();
  const [categories, setCategories] = useState<Category[]>([]);
  const [brands, setBrands] = useState<Brand[]>([]);
  const [products, setProducts] = useState<Product[]>([]);
  const [isLoading, setIsLoading] = useState(true);
  const [error, setError] = useState("");
  useEffect(() => {
    Promise.all([apiRequest<Category[]>("/categories"), apiRequest<Brand[]>("/brands"), apiRequest<{ products: Product[] }>("/products")])
      .then(([categoryData, brandData, productData]) => { setCategories(categoryData); setBrands(brandData); setProducts(productData.products); })
      .catch((err) => setError(err.message))
      .finally(() => setIsLoading(false));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  return <><ScrollToTop /><SeoManager /><Header />{error && <div className="api-error" data-testid="api-error-message">{error}</div>}<Routes><Route path="/" element={<HomePage categories={categories} products={products} />} /><Route path="/catalog" element={isLoading ? <main className="page-shell catalog-loading" data-testid="catalog-loading-state"><p className="eyebrow" data-testid="catalog-loading-eyebrow">Loading catalog</p><h1 data-testid="catalog-loading-heading">Products</h1></main> : <CatalogPage categories={categories} brands={brands} products={products} />} /><Route path="/product/:slug" element={<ProductPage products={products} />} /><Route path="/brands" element={<BrandsPage brands={brands} />} /><Route path="/cart" element={<CartPage />} /><Route path="/account" element={<AccountPage />} /><Route path="/admin" element={<AdminDashboardPage />} /><Route path="/quote" element={<QuotePage products={products} />} /><Route path="/wishlist" element={<WishlistPage products={products} />} /><Route path="/compare" element={<ComparePage products={products} />} /><Route path="/about" element={<AboutPage />} /><Route path="/shipping" element={<ShippingPage />} /><Route path="/returns" element={<ReturnsPage />} /><Route path="/shipping-returns" element={<ShippingPage />} /><Route path="/privacy" element={<PrivacyPage />} /><Route path="/privacy-policy" element={<PrivacyPage />} /><Route path="/terms" element={<TermsPage />} /><Route path="/accessibility" element={<AccessibilityPage />} /><Route path="/contact" element={<ContactPage />} /><Route path="/why-buy" element={<WhyBuyPage />} /><Route path="/trade" element={<TradePage />} /><Route path="/partner-with-us" element={<PartnerPage />} /><Route path="/location" element={<LocationPage />} /><Route path="/financing" element={<FinancingPage />} /><Route path="/faqs" element={<FAQPage />} /><Route path="/resources" element={<ResourcesPage />} /><Route path="/guides/:slug" element={<GuidePage />} /><Route path="/landing/:slug" element={<CategoryLandingPage />} /><Route path="/:slug" element={<EcommerceSlugPage categories={categories} brands={brands} products={products} />} /></Routes><Footer /></>;
}

function App() {
  return <ShopProvider><BrowserRouter><AppContent /></BrowserRouter></ShopProvider>;
}

export default App;